import { StateCreator } from "zustand";
import { WidgetStore, QuotaState, QuotaActions } from "../types";

const initialQuotaState: QuotaState = {
  hasQuota: true,
  quotaCheckComplete: false,
  remainingMinutes: 0,
};

export const createQuotaSlice: StateCreator<
  WidgetStore,
  [],
  [],
  QuotaState & QuotaActions
> = (set) => ({
  ...initialQuotaState,
  setHasQuota: (hasQuota) => set({ hasQuota }),
  setQuotaCheckComplete: (quotaCheckComplete) => set({ quotaCheckComplete }),
  setRemainingMinutes: (remainingMinutes) => set({ remainingMinutes }),
  resetQuota: () => set(initialQuotaState),
});
